import { useCallback, useState } from "react";
import type { MediaItem } from "../types";

export function useMediaSelection() {
  const [selectedItems, setSelectedItems] = useState<MediaItem[]>([]);

  const toggleSelection = useCallback((item: MediaItem) => {
    setSelectedItems((prev) => {
      const exists = prev.find((i) => i.id === item.id);
      if (exists) {
        return prev.filter((i) => i.id !== item.id);
      }
      return [...prev, item];
    });
  }, []);

  const selectAll = useCallback((items: MediaItem[]) => {
    setSelectedItems(items);
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedItems([]);
  }, []);

  const isSelected = useCallback(
    (id: string) => {
      return selectedItems.some((item) => item.id === id);
    },
    [selectedItems]
  );

  return {
    selectedItems,
    selectedCount: selectedItems.length,
    toggleSelection,
    selectAll,
    clearSelection,
    isSelected,
  };
}
